import { MdOutlineRefresh, MdOutlineOpenInFull, MdOutlineMoreVert } from 'react-icons/md';

export default function ChartCardHeader() {
    return (
        <div className="flex items-center justify-between">
            {/* <MdOutlineRefresh size={18} className="cursor-pointer text-[#999] hover:text-secondary" /> */}
            {/* <div className="flex items-center gap-2">
                <MdOutlineOpenInFull size={16} className="cursor-pointer text-[#999] hover:text-secondary" />
            </div> */}
        </div>
    );
}
